var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_vm._m(0),_c('div',{staticClass:"main public_box"},[_c('tenant-package-admin-hl')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_title"},[_c('b',[_vm._v("租户管理")])])
}]

export { render, staticRenderFns }